import Form from '../../common/form';
import Joi from 'joi';

class VICustomCoverItemForm extends Form {
	state = {
		data: { id: '', name: '' },
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		id: Joi.string().min(3).required().label('Inspection Standard Label'),
		name: Joi.string().min(3).required().label('Inspection Standard Value'),
	};

	doSubmit = () => {
		this.props.onAddCoverItem(this.state.data);

		this.setState({
			data: {
				id: '',
				name: '',
			},
		});
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<div className="form-title">Applicable Standards and Criteria</div>

				<div className="divider my-4"></div>

				{this.renderInput({
					type: 'text',
					name: 'id',
					placeholder: 'Enter Inspection Standard',
					label: 'Inspection Standard',
				})}

				<div className="divider my-4"></div>

				{this.renderInput({
					type: 'text',
					name: 'name',
					placeholder: 'Inspection Standard Value',
					label: 'Enter Inspection Standard Value',
				})}

				<div className="d-flex justify-content-end">
					{this.renderButton('Click to Add')}
				</div>
			</form>
		);
	}
}

export default VICustomCoverItemForm;
